export default __webpack_public_path__ + "static/media/side2.5b0aa76a.svg";